// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2P2seF7EsNRtVPgrUDdpUM
// Component: yG0j8VHQvbh7
import * as React from "react";
import { Link } from "gatsby";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Copyright from "../../Copyright"; // plasmic-import: smhgwqfGPU/component
import { useScreenVariants as useScreenVariantsvfX27Kk2D5M } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: VfX27Kk2d5M/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import * as projectcss from "./plasmic_isaacpalka_com.module.css"; // plasmic-import: 2P2seF7EsNRtVPgrUDdpUM/projectcss
import * as sty from "./PlasmicBooks.module.css"; // plasmic-import: yG0j8VHQvbh7/css
import hedgehogBookCoverFrontZsrJh1Rle034 from "./images/hedgehogBookCoverFront.png"; // plasmic-import: zsrJH1RLE034/picture
import hedgehogBookCoverBackDYmvc3Fvhewd from "./images/hedgehogBookCoverBack.jpg"; // plasmic-import: dYMVC3Fvhewd/picture

createPlasmicElementProxy;

export const PlasmicBooks__VariantProps = new Array();

export const PlasmicBooks__ArgProps = new Array();

const $$ = {};

export function Head() {
  return (
    <>
      <meta name="twitter:card" content="summary" />
      <title key="title">{PlasmicBooks.pageMetadata.title}</title>
      <meta
        key="og:title"
        property="og:title"
        content={PlasmicBooks.pageMetadata.title}
      />

      <meta
        key="twitter:title"
        name="twitter:title"
        content={PlasmicBooks.pageMetadata.title}
      />
    </>
  );
}

function PlasmicBooks__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsvfX27Kk2D5M()
  });
  return (
    <React.Fragment>
      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__bj1M5)}>
            <p.PlasmicLink
              data-plasmic-name={"back"}
              data-plasmic-override={overrides.back}
              className={classNames(
                projectcss.all,
                projectcss.a,
                projectcss.__wab_text,
                sty.back
              )}
              component={Link}
              href={`/`}
              platform={"gatsby"}
            >
              {"\u25c4 Back Home"}
            </p.PlasmicLink>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__tbJr9)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__vzDBh)}>
                <h1
                  data-plasmic-name={"h1"}
                  data-plasmic-override={overrides.h1}
                  className={classNames(
                    projectcss.all,
                    projectcss.h1,
                    projectcss.__wab_text,
                    sty.h1
                  )}
                >
                  {"Books"}
                </h1>
                <p
                  data-plasmic-name={"p"}
                  data-plasmic-override={overrides.p}
                  className={classNames(
                    projectcss.all,
                    projectcss.p,
                    projectcss.__wab_text,
                    sty.p
                  )}
                >
                  {"by Isaac Palka"}
                </p>
              </div>
              <div
                data-plasmic-name={"text"}
                data-plasmic-override={overrides.text}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text
                )}
              >
                {
                  "Welcome to my homepage! I've written only one children's book (so far). It's available for purchase on Amazon by clicking the image below. Feel free to explore the rest of my site."
                }
              </div>
              <p.Stack
                as={p.PlasmicLink}
                data-plasmic-name={"link"}
                data-plasmic-override={overrides.link}
                hasGap={true}
                className={classNames(projectcss.all, projectcss.a, sty.link)}
                component={Link}
                href={"https://a.co/d/hnQ9uSz"}
                platform={"gatsby"}
                target={"_blank"}
                title={"Buy on Amazon"}
              >
                <div className={classNames(projectcss.all, sty.freeBox__xtBb2)}>
                  <p.Stack
                    as={"div"}
                    hasGap={true}
                    className={classNames(projectcss.all, sty.freeBox__gVav3)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__e1Siw)}
                    >
                      <p.PlasmicImg
                        data-plasmic-name={"imageFront"}
                        data-plasmic-override={overrides.imageFront}
                        alt={""}
                        className={classNames(sty.imageFront)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: hedgehogBookCoverFrontZsrJh1Rle034,
                          fullWidth: 1000,
                          fullHeight: 1000,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__opqAm)}
                    >
                      <p.PlasmicImg
                        data-plasmic-name={"imageBack"}
                        data-plasmic-override={overrides.imageBack}
                        alt={""}
                        className={classNames(sty.imageBack)}
                        displayHeight={"auto"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"auto"}
                        loading={"lazy"}
                        src={{
                          src: hedgehogBookCoverBackDYmvc3Fvhewd,
                          fullWidth: 2550,
                          fullHeight: 2550,
                          aspectRatio: undefined
                        }}
                      />
                    </div>
                  </p.Stack>
                </div>
                <div
                  data-plasmic-name={"blurb"}
                  data-plasmic-override={overrides.blurb}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.blurb
                  )}
                >
                  {
                    "Join Henry the Hedgehog on his adventure to find a new hat to live in. Travel with him to incredible places from around the world, like the wild west and even outer space, and learn an important lesson along the way."
                  }
                </div>
              </p.Stack>
            </p.Stack>
          </div>
          <Copyright
            data-plasmic-name={"copyright"}
            data-plasmic-override={overrides.copyright}
            className={classNames("__wab_instance", sty.copyright)}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "back",
    "h1",
    "p",
    "text",
    "link",
    "imageFront",
    "imageBack",
    "blurb",
    "copyright"
  ],

  back: ["back"],
  h1: ["h1"],
  p: ["p"],
  text: ["text"],
  link: ["link", "imageFront", "imageBack", "blurb"],
  imageFront: ["imageFront"],
  imageBack: ["imageBack"],
  blurb: ["blurb"],
  copyright: ["copyright"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicBooks__ArgProps,
          internalVariantPropNames: PlasmicBooks__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicBooks__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicBooks";
  } else {
    func.displayName = `PlasmicBooks.${nodeName}`;
  }
  return func;
}

export const PlasmicBooks = Object.assign(
  // Top-level PlasmicBooks renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    back: makeNodeComponent("back"),
    h1: makeNodeComponent("h1"),
    p: makeNodeComponent("p"),
    text: makeNodeComponent("text"),
    link: makeNodeComponent("link"),
    imageFront: makeNodeComponent("imageFront"),
    imageBack: makeNodeComponent("imageBack"),
    blurb: makeNodeComponent("blurb"),
    copyright: makeNodeComponent("copyright"),
    // Metadata about props expected for PlasmicBooks
    internalVariantProps: PlasmicBooks__VariantProps,
    internalArgProps: PlasmicBooks__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "Books",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicBooks;
/* prettier-ignore-end */
